import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";
import { installPushClickRecorder } from "@/lib/pushClickRecorder";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Production only — see lib/pwa.js. Offers a refresh toast rather than
// reloading under the member's feet.
registerServiceWorker();

// Real-device push click journaller. Records `record_push_click` on load
// (URL ?ptrace) and on SW broadcast (already-open client). See
// lib/pushClickRecorder.js.
installPushClickRecorder();
